import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, MenuItem, Box } from '@material-ui/core';

function CustomMenuItem(props) {
  const useStyles = makeStyles(theme => ({
    menuItem: {
      height: '50px',
    },
    menuItemsText: {
      fontFamily: 'Museo-500',
      fontSize: '14px',
      lineHeight: '17px',
    },
    menuItemsIcons: {
      color: '#33b0ce',
      fontSize: '28px',
    },
  }));
  const classes = useStyles();

  const CustomMenuContent = props => (
    <Grid
      key={props.index}
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
    >
      {props.icon && (
        <Grid item xs={3}>
          <Box
            display="flex"
            justifyContent="center"
            className={classes.menuItemsIcons}
          >
            {props.icon}
          </Box>
        </Grid>
      )}

      <Grid item xs={9}>
        <Box>
          <Typography
            className={classes.menuItemsText}
            variant="h5"
            style={{ color: props.textColor }}
          >
            {props.upperCase ? props.text.toUpperCase() : props.text}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <MenuItem
      className={classes.menuItem}
      onClick={props.onClick}
      style={{
        ...props.style,
        backgroundColor: props.backgroundColor,
      }}
    >
      <CustomMenuContent
        icon={props.icon}
        text={props.text}
        upperCase={props.upperCase}
        textColor={props.textColor}
        style={props.style}
      />
    </MenuItem>
  );
}

export default CustomMenuItem;
